import {DatePicker, message} from "antd";
import {Controller, useFormContext} from "react-hook-form";
import moment from "moment";
import type {RangePickerProps} from "antd/es/date-picker";
import {
  StyledDiscountFormContainer,
  StyledDiscountFormItem,
} from "../styles/discount-form.styles";

const {RangePicker} = DatePicker;

export function DiscountCodeValidityFormFieldV2() {
  const {control, watch} = useFormContext();
  const disabledDate: RangePickerProps["disabledDate"] = (current) => {
    return current && current < moment().startOf("day");
  };

  return (
    <StyledDiscountFormContainer>
      <div className="form-header">Validity period</div>
      <div className="form-content">
        <StyledDiscountFormItem style={{marginBottom: 0}}>
          <div className="label-row">
            <label
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <span>Start date</span> <span style={{textAlign: "center"}}>End date</span>
            </label>
          </div>
          <Controller
            control={control}
            name="validity"
            render={({field: {onChange, value, onBlur, ref}, fieldState: {error}}) => (
              <>
                <RangePicker
                  size="large"
                  style={{width: "100%"}}
                  value={
                    value?.length > 0 ? [moment(value[0]), moment(value[1])] : undefined
                  }
                  onBlur={onBlur}
                  ref={ref}
                  status={error?.message ? "error" : ""}
                  disabledDate={disabledDate}
                  onChange={(date, dateStrings) => {
                    if (!date) {
                      onChange([]);
                    } else if (dateStrings) {
                      onChange(dateStrings);
                    } else {
                      message.error("Error selecting date");
                    }
                  }}
                />
                {error && (
                  <div role="alert" className="ant-form-item-explain-error">
                    {error.message}
                  </div>
                )}
              </>
            )}
          />
        </StyledDiscountFormItem>
      </div>
    </StyledDiscountFormContainer>
  );
}
